export enum USER_ROLES {
  NONE = 'NONE',
  SUPER_ADMIN = 'SUPER_ADMIN',
  ACCOUNT_MANAGER = 'ACCOUNT_MANAGER',
  OWNER = 'OWNER',
  MANAGER = 'MANAGER',
  HOST = 'HOST',
  SERVER = 'SERVER',
}

export enum USER_TYPES {
  SUPER_USER = 'USER_TYPE_SUPER_USER',
  ACCOUNT_MANAGER = 'USER_TYPE_ACCOUNT_MANAGER',
  OWNER = 'USER_TYPE_OWNER',
  USER = 'USER_TYPE_USER',
  EMPLOYEE = 'USER_TYPE_EMPLOYEE',
  DELIVER = 'USER_TYPE_DELIVER',
  PARTNER = 'USER_TYPE_PARTNER'
}

export const USER_TYPES_DATA = [
  {
    name: "Super Admin",
    value: USER_TYPES.SUPER_USER
  },
  {
    name: "Manager",
    value: USER_TYPES.ACCOUNT_MANAGER
  },
  {
    name: "Owner",
    value: USER_TYPES.OWNER
  },
  {
    name: "Guest",
    value: USER_TYPES.USER
  },
  {
    name: "Employee",
    value: USER_TYPES.EMPLOYEE
  },
  {
    name: "Partner",
    value: USER_TYPES.PARTNER
  },
]

export function getUserTypeName(type: USER_TYPES): any {
  const index = USER_TYPES_DATA.findIndex(value => value.value == type);
  if (index >=0) {
    return USER_TYPES_DATA[index].name;
  } else return "";
}

export enum PERMISSION_ACCESS {
  'NOT_SET' = "NOT SET", 'ALLOW' = "ALLOW", 'DENY' = "DENY"
}

